import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../theme/colors";

export type PersonsInfoVariant = "default" | "treatmentPlan";

export const PersonsContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "appearance",
})<{ appearance?: PersonsInfoVariant }>(({ theme, appearance = "default" }) => ({
  display: "flex",
  alignItems: "center",
  gap: appearance === "treatmentPlan" ? "18px" : "80px",
  borderRadius: appearance === "treatmentPlan" ? undefined : "16px",
  marginBottom: "32px",
  backgroundColor:
    appearance === "treatmentPlan" ? "transparent" : colors.background.default,
  padding: appearance === "treatmentPlan" ? 0 : "16px 24px",
  transition:
    "flex-direction 0.2s ease, gap 0.2s ease, margin-bottom 0.2s ease, padding 0.2s ease, border-radius 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: appearance === "treatmentPlan" ? "18px" : "16px",
    marginBottom: "16px",
    padding: appearance === "treatmentPlan" ? 0 : "12px 16px",
    borderRadius: appearance === "treatmentPlan" ? undefined : "8px",
  },
}));

export const PersonInfo = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

export const PersonAvatar = styled(Box)({
  width: "48px",
  height: "48px",
  borderRadius: "50%",
  backgroundColor: colors.background.lightBlue,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "18px",
  fontWeight: 600,
  color: colors.primary.main,
  flexShrink: 0,
});

export const PersonAvatarImage = styled("img")({
  width: "48px",
  height: "48px",
  borderRadius: "50%",
  objectFit: "cover",
  flexShrink: 0,
});

export const PersonDetails = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const PersonName = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "appearance",
})<{ appearance?: PersonsInfoVariant }>(({ appearance = "default" }) => ({
  fontFamily: "Nunito",
  fontSize: "18px",
  fontWeight: 700,
  color: colors.text.primary,
  lineHeight: appearance === "treatmentPlan" ? "32px" : undefined,
}));

export const PersonRole = styled(Typography, {
  shouldForwardProp: (prop) => prop !== "appearance",
})<{ appearance?: PersonsInfoVariant }>(({ appearance = "default" }) => ({
  fontSize: appearance === "treatmentPlan" ? "16px" : "12px",
  color: colors.text.secondary,
  fontFamily: "Nunito",
}));

export const PersonExtraInfo = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "24px",
  marginLeft: "auto",
});

export const PersonExtraItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "& svg": {
    width: "16px",
    height: "16px",
    color: colors.text.secondary,
  },
});

export const PersonExtraText = styled(Typography)({
  fontSize: "14px",
  color: colors.text.primary,
  fontFamily: "Nunito",
});
